export default __webpack_public_path__ + "search-overview-final-product-960-a65325206073f6ee800d2ae999ce667b.png";